import React, { useEffect, useMemo, useState } from "react";
import { useNavigate,Link } from "react-router-dom";
// import { useQuery } from "@tanstack/react-query";
import { getVisits } from "../api";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";


import { usePatientQueue } from "../hooks/usePatientQueue.js";
import PatientQueue         from "../components/PatientQueue.jsx";
import VideoRoom            from "../components/VideoRoom.jsx";
import DashboardTabs from "../components/DashboardTabs.js";

import moment from "moment";

const locales = { "en-US": require("date-fns/locale/en-US") };
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});



function VisitQueuePage({ onLogout }) {
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [viewMode, setViewMode] = useState("list"); // NEW toggle
  const [calendarView, setCalendarView] = useState("week"); // NEW calendar view

  const {
    sessions,
    activeSession,
    callStatus,
    queueError,
    callError,
    admitPatient,
    endCall,
    forceEndSession,
    refreshQueue,
  } = usePatientQueue();

  useEffect(() => {
   getVisits('').then((response) => {
    setSelectedFilter([...response]);
   }).catch((error)=>{}).finally(()=>{});
  }, [])

  const navReviewpage = (appointmentObj) => {
      navigate("/review", {
        state: {
          appointment: appointmentObj,
        },
      })
  }

  const handleTabChange = (tab) => {
    console.log("Selected tab:", tab);

    if (tab === "visits") {
      // Load visits

      navigate('/doctor-dashboard');
    }

    if (tab === "conference") {
      // Load conference
      navigate('/doctor-vqueue');
    }
  };
  


  return ( <div className='container' >
    <div style={{marginTop:'0px',paddingTop:'0px'}} >
{/* <DashboardTabs onTabChange={handleTabChange} name={'visits'} /> */}



      <div className="">
        {/* <div className="wf-bar">
          <span>📋 Medical Notes · Visit Queue</span>
        </div> */}

        {/* <div className="queue-header">
          <div>
            <h3 className="queue-title">
              Pending Review{" "}
              <span className="text-small">({selectedFilter?.length})</span>
            </h3>
          </div>
           <div>
               <Link to="/doctor-vqueue" className="book-btn">
                                Vedio Queue
                              </Link>
          </div>
         
        </div> */}
<div>
            <h3 className="queue-title my-4">
              Visits{" "}
              <span className="text-small">({selectedFilter?.length})</span>
            </h3>
          </div>
        
          <div className="queue-list" style={{height:'600px', maxHeight:'600px'}} >
            {selectedFilter?.map((visit) => (
              <div
                className="queue-item"
                key={`${visit.appointment_id}`}
              >
                <div>
                  <div className="visit-meta">
                    
                   <span style={{fontSize:'16px',fontWeight:'bold'}} > {visit.first_name? visit.first_name : 'Not Available' } </span>
                    <br /> Start Date: {visit.appointment_start?moment(visit.appointment_start).format('MM-DD-YYYY HH:mm'):""} · End Date {" "}
                    {visit.appointment_end?moment(visit.appointment_end).format('MM-DD-YYYY HH:mm'):""} 
                  </div>
                </div>
                <div className="queue-item-status">
                  <span
                    className={`wf-badge ${visit.appointment_status === "BOOKED" ? "pending" : "approved"}`}
                  >
                    {visit.appointment_status}
                  </span>
                  <button
                    className="wf-btn primary"
                    onClick={() => navReviewpage(visit)}
                  >
                    Review →
                  </button>
                </div>
              </div>
            ))}
          </div>
        
      </div>

    

    </div></div>
  );
}

export default VisitQueuePage;
